import makeAllIdsReducer from '../../../../creators/reducers/makeAllIdsReducer';
import makeByIdReducer from '../../../../creators/reducers/makeByIdReducer';
var model = "modal";
/**
 * Creator function that generates all modal model reducers
 *
 * @param {Object} options The options for the creator
 * @param {Object} options.customConfigs Any custom handlers for the reducers
 * @return {Object} The object holding all of the auth reducers
 *
 * @public
 * @author Alex Kasemir and Connor Taylor
 *
 * @example
 * import { combineReducers } from 'redux';
 *
 * const modal = combineReducers({ ...makeModalReducers() });
 * const rootReducer = combineReducers({
 *   modal,
 * });
 */

var makeModalReducers = function makeModalReducers(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$customConfig = _options.customConfigs,
      customConfigs = _options$customConfig === void 0 ? {} : _options$customConfig;
  return {
    allIds: makeAllIdsReducer({
      model: model,
      customConfig: customConfigs.allIds
    }),
    byId: makeByIdReducer({
      model: model,
      customConfig: customConfigs.byId
    })
  };
};
/** @component */


export default makeModalReducers;